import { render, staticRenderFns } from "./RSwitchButton.vue?vue&type=template&id=028133ea&scoped=true&"
import script from "./RSwitchButton.vue?vue&type=script&lang=js&"
export * from "./RSwitchButton.vue?vue&type=script&lang=js&"
import style0 from "./RSwitchButton.vue?vue&type=style&index=0&id=028133ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028133ea",
  null
  
)

export default component.exports